import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { buttonStyle, titleStyle } from '../../utils/commonCSS'
import { darkGrey, headingBlue, red } from '../../assets/colors'

const CustomDeleteDialog = (props) => {
  return (
    <>
    <Dialog maxWidth = 'xs' open={props.dialogStatus} onClose={() => props.updateFunc()}>
        <DialogTitle style={titleStyle}>
            Confirmation
        </DialogTitle>
        <DialogContent>
            <Box style={{padding: '1rem 0.5rem 1rem 0.5rem', color:headingBlue}}>
                <Typography> {props.message}</Typography>
            </Box>
            <Box style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button style={{...buttonStyle, backgroundColor: darkGrey}}
                    onClick={() => props.updateFunc()}
                >
                    Cancel
                </Button>
                <Button style={{...buttonStyle}}
                    onClick={() => props.deleteFunc()}
                >
                    Delete
                </Button>
            </Box>

        </DialogContent>

    </Dialog>
    </>
  )
}

export default CustomDeleteDialog
